import { apiAuth as api } from "@/lib/api";

// === BRAND PROFILE ===
export const getBrandProfile = () => api.get("/brand/profile").then((r) => r.data);
export const putBrandProfile = (p) => api.put("/brand/profile", p).then((r) => r.data);
export const suggestMission = (p) =>
  api.post("/brand/mission/suggest", p).then((r) => r.data);

// === PILLARS ===
export const listPillars = () => api.get("/brand/pillars").then((r) => r.data);
export const createPillar = (p) => api.post("/brand/pillars", p).then((r) => r.data);
export const updatePillar = (id, p) =>
  api.put(`/brand/pillars/${id}`, p).then((r) => r.data);
export const deletePillar = (id) =>
  api.delete(`/brand/pillars/${id}`).then((r) => r.data);
export const suggestPillars = () =>
  api.post("/brand/pillars/suggest").then((r) => r.data);

// === POSTS ===
export const listPosts = () => api.get("/posts").then((r) => r.data);
export const createPost = (p) => api.post("/posts", p).then((r) => r.data);
export const updatePost = (id, p) => api.put(`/posts/${id}`, p).then((r) => r.data);
export const deletePost = (id) => api.delete(`/posts/${id}`).then((r) => r.data);
export const requestFeedback = (id) =>
  api.post(`/posts/${id}/feedback`).then((r) => r.data);

// === COACH ===
export const listThreads = () => api.get("/coach/threads").then((r) => r.data);
export const getThread = (id) => api.get(`/coach/threads/${id}`).then((r) => r.data);
export const coachChat = (thread_id, message) =>
  api.post("/coach/chat", { thread_id, message }).then((r) => r.data);

// === DASHBOARD / DIGEST ===
export const dashboardSummary = () =>
  api.get("/dashboard/summary").then((r) => r.data);
export const weeklyDigest = () => api.get("/digest/weekly").then((r) => r.data);
